module.exports = __webpack_public_path__ + "img/switch_img2_msg2.376f5f68.png";